(() => {
  const init = root => {
    root.querySelectorAll('.gv-card-widget:not([data-initialized])').forEach(widget => {
      widget.dataset.initialized = 'true';
      const optin = widget.querySelector('.gv-card-optin');
      const fields = widget.querySelector('.gv-card-fields');
      const message = widget.querySelector('.gv-card-message');
      widget.addEventListener('change', event => event.stopPropagation());
      optin?.addEventListener('change', () => {
        fields.hidden = !optin.checked;
        message.required = optin.checked;
        if (optin.checked) message.focus();
      });
      widget.querySelector('.gv-card-cart-action')?.addEventListener('click', () => saveCartCard(widget));
    });
  };
  const cardProperties = widget => ({
    'Пожелание': widget.querySelector('.gv-card-message').value.trim(),
    'Към подарък': widget.dataset.giftTitle,
    '_grabvam_card': '1'
  });
  const isStickyAddCartForm = form => (form?.getAttribute('id') || '').startsWith('sticky-addcart-form-');
  const validate = form => {
    const widget = form?.querySelector('.gv-card-widget') || (isStickyAddCartForm(form) ? document.querySelector('.gv-card-widget[data-context="product"]') : null);
    if (!widget?.querySelector('.gv-card-optin')?.checked) return true;
    const message = widget.querySelector('.gv-card-message');
    message.required = true;
    if (!message.value.trim()) { message.value = ''; message.reportValidity(); return false; }
    return message.reportValidity();
  };
  const augmentFormData = (data, form) => {
    const widget = form?.querySelector('.gv-card-widget') || (isStickyAddCartForm(form) ? document.querySelector('.gv-card-widget[data-context="product"]') : null);
    if (!widget?.querySelector('.gv-card-optin')?.checked) return;
    for (const [key, value] of Array.from(data.entries())) {
      if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties[')) {
        data.delete(key);
        const indexed = key.startsWith('properties[') ? 'items[0][properties]' + key.slice('properties'.length) : `items[0][${key}]`;
        data.append(indexed, value);
      }
    }
    if (!data.has('items[0][quantity]')) data.append('items[0][quantity]', '1');
    data.append('items[1][id]', widget.dataset.cardVariant);
    data.append('items[1][quantity]', '1');
    Object.entries(cardProperties(widget)).forEach(([key,value]) => data.append(`items[1][properties][${key}]`, value));
  };
  const saveCartCard = async widget => {
    const message = widget.querySelector('.gv-card-message');
    message.required = true;
    if (!message.value.trim()) { message.value = ''; message.reportValidity(); return; }
    if (!message.reportValidity()) return;
    const button = widget.querySelector('.gv-card-cart-action');
    const error = widget.querySelector('.gv-card-error');
    button.disabled = true;
    error.hidden = true;
    const drawer = document.querySelector('cart-drawer');
    const sections = drawer?.getSectionsToRender?.().map(section => section.id) || [];
    const previousProperties = JSON.parse(widget.dataset.properties || '{}');
    const properties = {...(Array.isArray(previousProperties) ? Object.fromEntries(previousProperties) : previousProperties),...cardProperties(widget)};
    const payload = widget.dataset.lineKey
      ? {id:widget.dataset.lineKey,quantity:Number(widget.dataset.quantity),properties}
      : {items:[{id:Number(widget.dataset.cardVariant),quantity:1,properties}]};
    payload.sections = sections;
    payload.sections_url = window.location.pathname;
    try {
      const response = await fetch(widget.dataset.lineKey ? routes.cart_change_url : routes.cart_add_url, {
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400 || result.errors) throw new Error('cart');
      if (window.location.pathname.replace(/\/$/,'').endsWith('/cart')) { window.location.reload(); return; }
      if (drawer?.renderContents) {
        drawer.renderContents(result);
        const cart = await fetch(routes.cart_url + '.js',{headers:{'Accept':'application/json'}}).then(response => response.json());
        document.querySelectorAll('.cart-count').forEach(element => element.textContent = cart.item_count);
        document.querySelector('header-total-price')?.updateTotal?.(cart);
      } else window.location.assign(routes.cart_url);
    } catch {
      error.textContent = error.dataset.message;
      error.hidden = false;
      button.disabled = false;
    }
  };
  window.GrabvamCardAddon = {validate,augmentFormData};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length)) init(document);
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
